export default __webpack_public_path__ + "static/media/ThinkPackaging.326eb14f284a97e1089fde9a66795dbc.webp";